const socialYear =
  (new Date().getMonth() >= 10 && new Date().getDate() >= 15) ||
  new Date().getMonth() === 11 // after 15th of November
    ? new Date().getFullYear()
    : new Date().getFullYear() - 1;

export const CONFIG = {
  PRIVACY_DOCUMENT_URL:
    "https://bolognacngei.it/wp-content/uploads/2025/11/informativa_bologna.pdf",
  PRIVACY_IMAGE_URL:
    "https://bolognacngei.it/wp-content/uploads/2025/11/liberatoria-immagini-cngei.pdf",
  CURRENT_SOCIAL_YEAR: `${socialYear}-${socialYear + 1}`,
  SUPPORT_EMAIL: "bologna@cngei.it",
  TECH_SUPPORT_EMAIL: "webmasters@bolognacngei.it",
  END_REGISTRATION_DATE: `${socialYear}-12-22`,
  DATA_FINE_LUPETTI: `${socialYear - 11}-01-01`,
  DATA_FINE_ESPLORATORE: `${socialYear - 15}-01-01`,
  DATA_FINE_ROVER: `${socialYear - 18}-01-01`,
  IS_ISCRIZIONI_OPEN: true,
} as const;
